module.exports = __webpack_public_path__ + "static/media/bg-imag.7f4238fa.png";